import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CountryState {
  country?: string;
  setCountry: (country: string) => void;
}

const useCountryStore = create<CountryState>()(
  persist(
    (set) => ({
      country: undefined,
      setCountry: (country: string) => set({ country }),
    }),
    {
      name: "country-storage",
    }
  )
);

export { useCountryStore };
